export default __webpack_public_path__ + "static/media/TimeYellow.0e3be2d4.svg";